import { useLang } from '../../_metronic/i18n/Metronici18n'

const TermsOfServiceContent = () => {

  const selectedLang = useLang()

  return selectedLang === 'en' ?
      <>
        <h6>Introduction</h6>
        <p>These Terms of Service ("Terms") govern your use of Fanar, a series of Large Language Models and related
          services, developed by the Qatar Computing Research Institute (QCRI) at Hamad Bin Khalifa University (HBKU), a
          member of Qatar Foundation for Education, Science, and Community Development (QF), and sponsored by the
          Ministry of Communications and Information Technology (MCIT). By accessing or using Fanar, you agree to be
          bound by these Terms. If you disagree with any part of the Terms, you may not access Fanar.</p>
        <h6>Definitions</h6>
        <ul>
          <li><strong>Fanar</strong>: A series of Large Language Models and related services developed by the Qatar
            Computing Research Institute.</li>
          <li><strong>User</strong>: Any individual or entity accessing or using Fanar.</li>
          <li><strong>Services</strong>: All features, functionalities, and content provided by Fanar.</li>
          <li><strong>Providers</strong>: Qatar Computing Research Institute at Hamad Bin Khalifa University, a member
            of the Qatar Foundation.</li>
        </ul>
        <br/>
        <ol>
          <li><strong> Usage Requirements</strong></li>
        </ol>
        <p><strong>Registration and Access</strong></p>
        <p>Minimum Age: You must be at least 13 years old or the minimum age required in your country to use the
          Services. If you are under 18, you must have your parent's or legal guardian's permission to use the Services.
        </p>
        <p>Registration: You must provide accurate and complete information to use our Services. You may not share your
          account credentials or make your account available to anyone else and are responsible for all activities that
          occur under your account.</p>
        <p><strong>Informational Purposes Only</strong></p>
        <p>Fanar is intended for informational purposes only and should not be considered a substitute for professional
          advice, including legal, medical, or financial advice. No professional-client relationship is established
          through the use of Fanar.</p>
        <p><strong>Compliance with Laws</strong></p>
        <p>You agree to use Fanar in compliance with all applicable laws, rules, and regulations. These laws include
          those in your jurisdiction, as well as the laws of Qatar.</p>
        <p><strong>User Conduct</strong></p>
        <p>You agree not to use Fanar in any manner that could damage, disable, overburden, or impair the service or
          interfere with any other party's use and enjoyment.</p>
        <p>You may not misuse Fanar in any way, including but not limited to illegal, harmful, or abusive
          activity.&nbsp;</p>
        <br/>
        <ol start={2}>
          <li><strong> Content</strong></li>
        </ol>
        <p><strong>Disclaimer of Accuracy</strong></p>
        <p>The Providers do not guarantee the
          accuracy, completeness, or usefulness of any content provided. The content is provided "as is" without any
          warranties. You should verify important information by consulting authoritative and trusted sources.</p>
        <p><strong>Disclaimer of Official Views</strong></p>
        <p>The content generated by Fanar does not reflect the official views, positions, or opinions of the Providers
          or any other entity in Qatar.</p>
        <p><strong>Current Information</strong></p>
        <p>The content provided by Fanar may not always reflect the most current information available. Users are
          encouraged to independently verify the information and consult official sources or relevant professionals.</p>
        <p><strong>Intellectual Property Rights</strong></p>
        <p>All intellectual property rights related to Fanar, including content, software, trademarks, and logos, are
          owned by the Providers. Users are granted a limited, non-exclusive license to use the Services for personal
          and non-commercial purposes only.</p>
        <br/>
        <ol start={3}>
          <li><strong> Confidentiality, Security, and Data Protection</strong></li>
        </ol>
        <p><strong>Security Measures</strong></p>
        <p>We take reasonable measures to protect the security of your personal information. However, no method of
          transmission or electronic storage is completely secure. We cannot guarantee absolute security, and any
          transmission of information is at your own risk.</p>
        <p><strong>Data Usage and Privacy</strong></p>
        <p>Any information or material you provide to Fanar may be accessed by the Providers to enhance the service. We
          will never sell your data and will use it solely for service improvement. All data analysis will be conducted
          anonymously. However, we may be required to release your data to comply with legal obligations.</p>
        <br/>
        <ol start={4}>
          <li><strong> Terms and Termination</strong></li>
        </ol>
        <p><strong>Termination of Access</strong></p>
        <p>These Terms will remain in full force and effect while you use Fanar. The Providers reserve the right to
          terminate or suspend your access to Fanar at any time without notice for any reason, including but not limited
          to a breach of these Terms. Where feasible, notice will be provided prior to termination.</p>
        <p><strong>Surviving Clauses</strong></p>
        <p>Upon termination, all provisions of these Terms which by their nature should survive termination shall
          survive, including, without limitation, ownership provisions, warranty disclaimers, indemnity, and limitations
          of liability.</p>
        <br/>
        <ol start={5}>
          <li><strong> Disclaimer of Warranties and Limitation of Liability</strong></li>
        </ol>
        <p><strong>DISCLAIMER OF WARRANTIES</strong></p>
        <p>FANAR AND IT SERVICES ARE PROVIDED "AS IS." TO THE EXTENT PERMITTED BY LAW, WE PROVIDE NO WARRANTIES, WHETHER
          EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, WITH RESPECT TO THE SERVICES. WE DISCLAIM ALL WARRANTIES INCLUDING,
          BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, SATISFACTORY QUALITY,
          NON-INFRINGEMENT, AND QUIET ENJOYMENT, AS WELL AS ANY WARRANTIES ARISING FROM USAGE OF TRADE OR COURSE OF
          DEALING. WE DO NOT GUARANTEE THAT THE SERVICES WILL BE UNINTERRUPTED, ACCURATE, OR ERROR-FREE, OR THAT CONTENT
          WILL BE SECURE AND FREE FROM LOSS OR ALTERATION.</p>
        <p>YOU ACKNOWLEDGE AND ACCEPT THAT ANY USE OF OUTPUTS FROM OUR SERVICES IS AT YOUR OWN RISK. YOU SHOULD NOT RELY
          ON THE OUTPUTS AS THE SOLE SOURCE OF TRUTH OR FACTUAL INFORMATION NOR AS A SUBSTITUTE FOR PROFESSIONAL ADVICE.
        </p>
        <p><strong>LIMITATION OF LIABILITY</strong></p>
        <p>WE ARE NOT LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT
          NOT LIMITED TO LOSS OF PROFITS, GOODWILL, USE, OR DATA, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF
          SUCH DAMAGES. THE LIMITATIONS IN THIS SECTION APPLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAWS.</p>
        <br/>
        <ol start={6}>
          <li><strong> Governing Law and Jurisdiction</strong></li>
        </ol>
        <p>These Terms are governed by the laws of the State of Qatar. Any disputes arising out of or relating to these
          Terms shall be resolved in the courts of the State of Qatar.</p>
        <br/>
        <ol start={7}>
          <li><strong> Modification of Terms</strong></li>
        </ol>
        <p>The Providers reserve the right to modify these Terms at any time. Users will be notified of significant
          changes via email or a notice on the website. Continued use of Fanar after modifications constitutes
          acceptance of the updated Terms.</p>
        <br/>
        <ol start={8}>
          <li><strong> Severability</strong></li>
        </ol>
        <p>If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will
          continue in effect.</p>
        <br/>
        <ol start={9}>
          <li><strong> Entire Agreement</strong></li>
        </ol>
        <p>These Terms constitute the entire agreement between the user and the Providers regarding the use of Fanar and
          supersede any prior agreements.</p>
        <br/>
        <ol start={10}>
          <li><strong> Third-Party Links</strong></li>
        </ol>
        <p>Fanar may contain links to third-party websites. The Providers are not responsible for the content or
          practices of these third-party sites.</p>
        <br/>
        <ol start={11}>
          <li><strong> User Consent Mechanism</strong></li>
        </ol>
        <p>By using Fanar, you confirm that you have read, understood, and agree to these Terms of Service.</p>
      </>
      :
      <>
        <h6>المقدمة</h6>
        <p>تحكم هذه الشروط والأحكام استخدامك لفنار، وهي سلسلة من النماذج اللغوية الكبيرة والخدمات المرتبطة بها التي طورها معهد قطر لبحوث الحوسبة في جامعة حمد بن خليفة، هي عضو في مؤسسة قطر للتربية، والعلوم،  وتنمية المجتمع. باستخدامك لفنار، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء من هذه الشروط، فلا يحق لك استخدام فنار.</p>
        <h6>التعريفات</h6>
        <ul>
          <li><strong>فنار</strong> سلسلة من النماذج اللغوية الكبيرة والخدمات المرتبطة بها التي طورتها معهد قطر لبحوث الحوسبة.</li>
          <li><strong>المستخدم</strong> أي فرد أو كيان يستخدم فنار.</li>
          <li><strong>الخدمات</strong> جميع الميزات والوظائف والمحتويات التي يوفرها فنار.</li>
          <li><strong>مقدمو الخدمة</strong> معهد قطر لبحوث الحوسبة في جامعة حمد بن خليفة، عضو مؤسسة قطر.</li>
          </ul>
          <br/>
          <ol>
          <li><strong>	متطلبات الاستخدام</strong></li>
          </ol>
          <p><strong>التسجيل والوصول</strong></p>
          <p>الحد الأدنى للعمر: يجب أن يكون عمرك على الأقل 13 عامًا أو الحد الأدنى للعمر المطلوب في بلدك لاستخدام الخدمات. إذا كنت تحت سن 18، يجب أن تحصل على إذن من والديك أو الوصي القانوني لاستخدام الخدمات.</p>
          <p>التسجيل: يجب أن تقدم معلومات دقيقة وكاملة للتسجيل لاستخدام خدماتنا. لا يجوز لك مشاركة بيانات اعتماد حسابك أو إتاحة حسابك لأي شخص آخر، وأنت مسؤول عن جميع الأنشطة التي تحدث بموجب حسابك.</p>
          <p><strong>لأغراض إعلامية فقط</strong></p>
          <p>تم تصميم فنار لأغراض معلوماتية فقط، ولا ينبغي اعتباره بديلاً عن المشورة المهنية، بما في ذلك المشورة القانونية أو الطبية أو المالية. لا ينشأ عن استخدام فنار أي علاقة مهنية بينك وبين مقدمي الخدمة.</p>
          <p><strong>الامتثال للقوانين</strong></p>
          <p>أنت توافق على استخدام فنار وفقًا لجميع القوانين والقواعد واللوائح المعمول بها. وتشمل هذه القوانين في نطاق سلطتك القضائية وكذلك قوانين دولة قطر.</p>
          <p><strong>سلوك المستخدم</strong></p>
          <p>أنت توافق على عدم استخدام فنار بأي طريقة يمكن أن تتسبب في إلحاق الضرر، أو تعطيل الخدمة ،أو تحميلها بشكل مفرط، أو التأثير على استخدامها من قبل الآخرين.</p>
          <p>يحظر إساءة استخدام فنار بشكل صارم، بما في ذلك على سبيل المثال لا الحصر:</p>
          <ul>
            <li>استخدام الخدمات بطريقة تنتهك أو تسيء إلى حقوق أي شخص.</li>
            <li>تعديل أو نسخ أو تأجير أو بيع أو توزيع أي جزء من خدماتنا.</li>
            <li>الادعاء بأن المحتوى الذي تقدمه خدماتنا قد تم إنشاؤه بواسطة البشر عندما لا يكون كذلك.</li>
            <li>التدخل في خدماتنا أو تعطيلها، بما في ذلك تجاوز أي قيود أو حماية أمان وضعناها.</li>
            </ul>
          <ol start={2}>
          <li><strong> 	المحتوى</strong></li>
          </ol>
          <p><strong>إخلاء مسؤولية الدقة</strong></p>
          <p>لا يضمن مقدمو الخدمة دقة أو اكتمال أو فائدة أي معلومات مقدمة. يتم توفير المحتوى "كما هو"، بدون أي ضمانات. يجب عليك التحقق من المعلومات الهامة من خلال مصادر موثوقة.</p>
          <p><strong>إخلاء المسؤولية عن الآراء الرسمية</strong></p>
          <p>المحتوى الذي يقدمه فنار لا يعكس الآراء أو المواقف الرسمية لمقدمي الخدمة أو أي كيان آخر في قطر.</p>
          <p><strong>المعلومات الحالية</strong></p>
          <p>قد لا يعكس المحتوى الذي يقدمه فنار دائمًا أحدث المعلومات المتاحة. على المستخدمين التحقق من المعلومات بشكل مستقل، واستشارة المصادر الرسمية أو المهنيين المختصين عند الحاجة.</p>
          <p><strong>حقوق الملكية الفكرية</strong></p>
          <p>جميع حقوق الملكية الفكرية المتعلقة بفنار، بما في ذلك المحتوى والبرمجيات والعلامات التجارية والشعارات، مملوكة لمقدمي الخدمة. يُمنح المستخدمون ترخيصًا محدودًا وغير حصري لاستخدام الخدمات لأغراض شخصية وغير تجارية فقط.</p>
          <br/>
          <ol start={3}>
          <li><strong>السرية والأمان وحماية البيانات</strong></li>
          </ol>
          <p><strong>إجراءات الأمان</strong></p>
          <p>نتخذ تدابير معقولة لحماية أمان معلوماتك الشخصية. ومع ذلك، لا توجد طريقة نقل أو تخزين إلكتروني آمنة تمامًا. لا يمكننا ضمان الأمان المطلق، وأي نقل للمعلومات يكون على مسؤوليتك الشخصية.</p>
          <p><strong>استخدام البيانات والخصوصية</strong></p>
          <p>قد يحتاج مقدمو الخدمة استعمال معلومات أو مواد تقدمها لفنار لتحسين الخدمة. لن نقوم أبدًا ببيع بياناتك وسيتم استخدامها فقط لتحسين الخدمة. سيتم إجراء جميع تحليلات البيانات بشكل مجهول. ومع ذلك، قد نضطر إلى الإفصاح عن بياناتك للامتثال للالتزامات القانونية.</p>
          <br/>
          <ol start={4}>
          <li><strong>الشروط والإنهاء</strong></li>
          </ol>
          <p><strong>إنهاء الوصول</strong></p>
          <p>ستظل هذه الشروط سارية المفعول طالما أنك تستخدم فنار. يحتفظ مقدمو الخدمة بالحق في إنهاء أو تعليق وصولك إلى فنار في أي وقت دون إشعار ولأي سبب، بما في ذلك، على سبيل المثال لا الحصر، انتهاك هذه الشروط. عندما يكون ذلك ممكنًا، سيتم إرسال الإشعار قبل الإنهاء.</p>
          <p><strong>البنود النافذة بعد الإنهاء</strong></p>
          <p>عند الإنهاء، ستظل جميع البنود التي بطبيعتها يجب أن تبقى سارية بعد الإنهاء، بما في ذلك، على سبيل المثال لا الحصر، بنود الملكية، وإخلاء الضمان، والتعويضات، وحدود المسؤولية.</p>
          <br/>
          <ol start={5}>
          <li><strong>	إخلاء المسؤولية وحدود المسؤولية</strong></li>
          </ol>
          <p><strong>إخلاء المسؤولية عن الضمانات</strong></p>
          <p>يتم تقديم فنار وخدماته "كما هي". إلى الحد الذي يسمح به القانون، نحن لا نقدم أي ضمانات، سواء كانت صريحة أو ضمنية أو قانونية أو غير ذلك، فيما يتعلق بالخدمات. نحن نخلي مسؤوليتنا عن جميع الضمانات بما في ذلك، ولكن ليس على سبيل الحصر، ضمانات القابلية للتسويق، والملاءمة لغرض معين، والجودة المرضية، وعدم الانتهاك، والتمتع الهادئ، بالإضافة إلى أي ضمانات ناشئة عن استخدام التجارة أو سير التعامل. نحن لا نضمن أن الخدمات ستكون غير منقطعة، دقيقة، خالية من الأخطاء، أو أن المحتوى سيكون آمنًا وخاليًا من الخسارة أو التغيير.</p>
          <p>أنت تقر وتوافق على أن أي استخدام للمخرجات من خدماتنا يكون على مسؤوليتك الخاصة. لا ينبغي لك الاعتماد على المخرجات كمصدر وحيد للحقيقة أو المعلومات الواقعية، ولا كبديل عن المشورة المهنية.</p>
          <p><strong>حدود المسؤولية</strong></p>
          <p>نحن غير مسؤولين عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو تعويضات عقابية، بما في ذلك، على سبيل المثال لا الحصر، فقدان الأرباح أو السمعة أو الاستخدام أو البيانات، حتى إذا تم إخطارنا بإمكانية حدوث مثل هذه الأضرار. تُطبّق  القيود الواردة في هذا القسم إلى أقصى حد يسمح به القانون.</p>
          <br/>
          <ol start={6}>
          <li><strong>	القانون الواجب التطبيق والاختصاص القضائي</strong></li>
          </ol>
          <p>تخضع هذه الشروط لقوانين دولة قطر. يتم حل أي نزاعات تنشأ عن أو تتعلق بهذه الشروط في محاكم دولة قطر.</p>
          <br/>
          <ol start={7}>
          <li><strong> 	تعديل الشروط</strong></li>
          </ol>
          <p>يحتفظ مقدمو الخدمة بالحق في تعديل هذه الشروط في أي وقت. سيتم إخطار المستخدمين بالتغييرات الهامة عبر البريد الإلكتروني أو إشعار على الموقع. يُعد استمرار استخدامك لفنار بعد التعديلات قبولاً للشروط المعدلة.</p>
          <br/>
          <ol start={8}>
          <li><strong>	قابلية الفصل</strong></li>
          </ol>
          <p>إذا وجد أي بند من هذه الشروط غير صالح أو غير قابل للتنفيذ، فإن الأحكام المتبقية ستظل سارية المفعول.</p>
          <br/>
          <ol start={9}>
          <li><strong> 	الاتفاقية الكاملة</strong></li>
          </ol>
          <p>تشكل هذه الشروط الاتفاقية الكاملة بين المستخدم ومقدمي الخدمة فيما يتعلق باستخدام فنار وتُلغي أي اتفاقيات سابقة.</p>
          <br/>
          <ol start={10}>
          <li><strong>الروابط إلى جهات خارجية</strong></li>
          </ol>
          <p>قد يحتوي فنار على روابط لمواقع ويب تابعة لأطراف خارجية. لا يتحمل مقدمو الخدمة المسؤولية عن محتوى أو ممارسات هذه المواقع.</p>
          <br/>
          <ol start={11}>
          <li><strong>آلية موافقة المستخدم</strong></li>
          </ol>
          <p>باستخدامك لفنار، فإنك تؤكد أنك قد قرأت وفهمت وتوافق على هذه الشروط والأحكام.</p>
      </>
  }
  
  export default TermsOfServiceContent